export function getUserSourcePath() {
  return sessionStorage?.getItem('amplitude-source') || 'entrance'
}
